import { Stack as MuiStack } from '@mui/material';
export const Stack = MuiStack;

//# sourceMappingURL=Stack.js.map